import { handleActions } from 'redux-actions'

const LOAD = 'env_config/LOAD'

const initialState = {}

export default handleActions({
  [LOAD]: (state, { payload }) => ({ ...state, ...payload }),
}, initialState)
